import { render, staticRenderFns } from "./PatientLabResultsCard.vue?vue&type=template&id=1a816758&scoped=true&"
import script from "./PatientLabResultsCard.vue?vue&type=script&lang=js&"
export * from "./PatientLabResultsCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientLabResultsCard.vue?vue&type=style&index=0&id=1a816758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a816758",
  null
  
)

export default component.exports